var Iframe_default = {
  "iframe": "_61VU2"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
